// modals/CriticalAlertsShareModal.jsx
import React from 'react';
import { Dialog, DialogTitle, IconButton, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CriticalAlerts from 'careiq/ui/criticalalerts';

const CriticalAlertsShareModal = ({ open, onClose, patient_insights }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md" // options: 'xs', 'sm', 'md', 'lg', 'xl'
      PaperProps={{ style: { backgroundColor: '#f9fafb', borderRadius: '8px' } }}
    >
      <div className="p-4 flex justify-between items-center bg-white border-b">
        <h2 className="text-xl font-semibold text-blue-800">Critical Alerts View</h2>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent dividers className="p-4">
        <div className="max-w-4xl mx-auto">
          <CriticalAlerts view={1} patient_insights={patient_insights} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CriticalAlertsShareModal;
